import { FunctionComponent, PropsWithChildren, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from '@cbridge-utils/react-redux';
import { userSettingSelector } from '@cbridge-packages/user-settings';
import { isLanguage, LANGUAGE_SETTING_KEY } from '../i18n.constant';

/**
 * Applies the language saved in the user profile (priority: profile → last choice in this browser → browser language → default).
 * A missing or outdated profile value (the source locale, a pruned language) keeps the detected language. Mount inside UserSettingsGate.
 */
export const LanguageSync: FunctionComponent<PropsWithChildren> = ({ children }) => {
  const { i18n } = useTranslation();
  const savedLanguage = useSelector(userSettingSelector, { settingKey: LANGUAGE_SETTING_KEY });
  const profileLanguage = isLanguage(savedLanguage) ? savedLanguage : null;

  useEffect(() => {
    if (profileLanguage && profileLanguage !== i18n.language) {
      void i18n.changeLanguage(profileLanguage);
    }
  }, [i18n, profileLanguage]);

  return children;
};
